// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable react/sort-comp, react/destructuring-assignment, init-declarations */
import * as React from "react"

import { get } from "../../utils/get"
import { oneTimeAnimate } from "../../services/utils/animations"
import fieldValidation from "../../utils/fieldValidation"

export type SpFieldFunc = {
  setDirty: () => void
  shouldShowState: () => boolean
  hasError: () => boolean
  renderError: () => React.ReactNode | string
  renderLabel: () => React.ReactNode | null | undefined
  getClasses: () => string
  getValidationClasses: () => string
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createValueLink: (props: any) => any
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const spFieldWrapper = (WrappedComponent: React.ComponentType<any>) =>
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  class extends React.Component<any, any> {
    static defaultProps = {
      inputStyle: "twoLines", // twoLines, oneLine
    }

    fieldRef = React.createRef<HTMLElement>()

    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props: any) {
      super(props)

      // @ts-expect-error: Flow to TS migration.
      this.spFieldFunc = {
        setDirty: this.setDirty,
        shouldShowState: this.shouldShowState,
        hasError: this.hasError,
        renderError: this.renderError,
        renderLabel: this.renderLabel,
        getClasses: this.getClasses,
        getValidationClasses: this.getValidationClasses,
        createValueLink: this.createValueLink,
      }
    }

    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/member-ordering
    state = {
      dirty: false,
    }

    // FIXME: sort methods in React components according to conventions

    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/member-ordering
    spFieldFunc = null

    setDirty = () => {
      this.setState({
        dirty: true,
      })
    }

    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    getClasses = (): string => ` _${this.props.inputStyle} ${this.getValidationClasses()} `

    getValidationClasses = (): string => {
      if (this.shouldShowState() && this.hasError()) {
        return " _error "
      }
      if (this.shouldShowState() && !this.hasError()) {
        return " _ok "
      }
      // Validation for select field  from redux form
      if (this.props.touched && this.props.error) {
        return " _error"
      }
      if ((this.props.invalid && this.props.touched) || this.props.contextError) {
        return " _error"
      }
      if (this.props.touched && this.props.valid) {
        return " _ok"
      }

      return ""
    }

    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    createValueLink = (props: any): any => {
      const { disableShaking, isMobile, normalize, onChange, valueLink, maxLength } = props

      const value = valueLink ? valueLink.value : props.value

      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const handleChange = (val: any) => {
        // @ts-expect-error: Flow to TS migration.
        let normalizedValue

        if (Array.isArray(normalize)) {
          normalizedValue = val

          normalize.forEach((normalizer) => {
            normalizedValue = normalizer
              ? // @ts-expect-error: Flow to TS migration.
                normalizer(normalizedValue, props.maxLength)
              : // @ts-expect-error: Flow to TS migration.
                normalizedValue
          })
        } else {
          normalizedValue = normalize ? normalize(val) : val
        }

        if (
          this.fieldRef.current &&
          normalize &&
          val !== normalizedValue &&
          !isMobile &&
          !disableShaking
        ) {
          oneTimeAnimate(this.fieldRef.current, "spShake")
        }

        if (valueLink) {
          return valueLink.requestChange(normalizedValue)
        }

        return onChange(normalizedValue, maxLength)
      }

      const safeValue = value || ""

      return {
        value: props.format && props.value && !props.active ? props.format(safeValue) : safeValue,
        // @ts-expect-error: Flow to TS migration.
        onChange: (e) => handleChange(e.target.value),
      }
    }

    hasError = (): boolean =>
      Boolean(this.props.valueLink && get(["valueLink", "errors", "length"], this.props))

    shouldShowState = (): boolean =>
      Boolean(this.state.dirty || get(["valueLink", "forceShowState"], this.props))

    renderError = (): React.ReactNode | string => {
      if (this.hasError() && this.shouldShowState()) {
        return (
          <div className="spField-error">
            {
              // @ts-expect-error: Flow to TS migration.
              this.props.valueLink.errors.map((message) => (
                <span className="spField-note spTypo-note" key={message}>
                  {message}
                </span>
              ))[0]
            }
          </div>
        )
      }
      return ""
    }

    renderLabel = (): React.ReactNode | null | undefined => {
      if (this.props.label) {
        return (
          <div className="spField-label">
            {this.props.label ? this.props.label : ""}
            {this.props.hintText && (
              <span className="spField-hintText"> - {this.props.hintText}</span>
            )}
          </div>
        )
      }

      return null
    }

    render = () => {
      const validation = fieldValidation({
        ok: this.getClasses().includes("_ok"),
        error: this.getClasses().includes("_error"),
      })
      return (
        <WrappedComponent
          dirty={this.state.dirty}
          spFieldFunc={this.spFieldFunc}
          ref={this.fieldRef}
          {...this.props}
        >
          {validation.icon}
          {this.props.children}
        </WrappedComponent>
      )
    }
  }

export default spFieldWrapper
